import styled from 'styled-components';
import { Typography } from '@/components/UI/Typography/Typography.styles';

export const AdForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  margin-top: 5px;

  @media (max-width: 949px) {
    gap: 10px;
    margin-top: 20px;
    padding: 0 40px;
  }

  @media (max-width: 743px) {
    gap: 5px;
    margin-top: 5px;
    padding: 0;
  }
`;

export const AdFormPhoneMsgBox = styled.div`
  @media (max-width: 949px) {
    margin-top: 5px;
  }
`;

export const AdFormPhoneMsg = styled(Typography.Title)`
  color: ${({ theme }) => theme.palette.secondary.labels};

  @media (max-width: 949px) {
    font-size: 12px;
  }
`;

export const AdFormPhoneMsgInBox = styled(Typography.Title)`
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.system.lightBlue};
  padding: 10px 20px;
  margin-top: 10px;
  font-size: 12px;
`;

export const AdFormSubmitBox = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
  width: 100%;

  @media (max-width: 949px) {
    display: flex;
    flex-direction: column-reverse;
    gap: 15px;
    margin-top: 5px;
  }
`;

export const AdFormMsg = styled(Typography.Caption)`
  color: ${({ theme }) => theme.palette.tertiary.labels};

  a {
    color: ${({ theme }) => theme.palette.system.blue};
  }

  @media (max-width: 949px) {
    text-align: center;
    font-size: 12px;
  }
`;

export const AdFormSectionCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px 18px;
  padding: 40px;
  border-radius: 21px;
  width: 100%;
  border: 1px solid ${({ theme }) => theme.palette.primary.border};
  background: ${({ theme }) => theme.palette.primary.background};

  @media (max-width: 949px) {
    gap: 15px 18px;
    max-width: 640px;
    padding: 30px 50px;
    border: 1px solid ${({ theme }) => theme.palette.primary.background};
  }

  @media (max-width: 743px) {
    padding: 15px;
  }
`;

export const AdFormSectionTitle = styled(Typography.Title)`
  width: 100%;
  font-size: 20px;
  margin-bottom: 10px;

  @media (max-width: 949px) {
    font-size: 18px;
    padding: 5px 0;
    margin-bottom: 5px;
  }
`;

export const AdFormAdStaticInfoContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 10px;
  width: 100%;

  @media (max-width: 949px) {
    margin-bottom: 5px;
  }
`;

export const AdFormAdStaticInfoTitle = styled(Typography.Title)`
  font-size: 20px;
`;

export const EmailFieldWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 15px;

  @media (max-width: 949px) {
    gap: 10px;
  }
`;

export const EmailInputWrapper = styled.div`
  position: relative;
`;

export const EmailStatusIcon = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  width: 25px;
  top: 50%;
  right: 15px;
  transform: translateY(-50%);
`;

export const EmailWarningDescription = styled(Typography.Body)`
  padding: 16px 15px;
  border-radius: 14px;
  background-color: ${({ theme }) => theme.palette.system.lightYellow};
  font-size: 12px;
`;
